export const getCommonHeaderOptions = (defaultHeader = {}) => {
  return {
    headers: {
      "Content-Type": "application/json",
      ...defaultHeader,
    },
  };
};

export const isEmpty = (value) => {
  return value === null || value === undefined || value.length === 0;
};

export const setStorageWithExpiry = (key, value, ttl) => {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getStorageWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};

export const formatDate = (date) => {
  var day = date.getDate();
  var month = date.toLocaleString("default", { month: "short" });
  var year = date.getFullYear().toString();
  return day + " " + month + ", " + year;
};

export const RATING_KEYS = [
  {
    id: 5,
    key: "Highly recommend",
    desc: "Tell us what you loved",
  },
  {
    id: 4,
    key: "Good",
    desc: "Tell us what you liked",
  },
  {
    id: 3,
    key: "Average",
    desc: "Tell us what you liked and disliked",
  },
  {
    id: 2,
    key: "Not good",
    desc: "Tell us what you disliked",
  },
  {
    id: 1,
    key: "Wouldn't recommend",
    desc: "Tell us why",
  },
];
export const scrollRequired = (scrollContainer) => {
  const distanceToBottom = scrollContainer.scrollHeight - (scrollContainer.scrollTop + scrollContainer.clientHeight);
  // console.log("here: ", scrollContainer.scrollHeight, scrollContainer.scrollTop, scrollContainer.clientHeight, scrollContainer.scrollHeight - (scrollContainer.scrollTop + scrollContainer.clientHeight));
  const threshold = window.innerWidth <= 430 ? 50 : 100;
  // If at the bottom, call your function or perform the desired action
  return distanceToBottom < threshold;
};
export const getEventData = (loggedIn,page, product, review) => {
  let eventData = {
    login_status: loggedIn ? 'logged_in' : 'logged_out',
    page_type: 'web',
    unit_name: page,
    product_id: product.uid,
    name: product.name,
    brand: product.brand.name,
    category: product.category_map.l1.name,
    category2: product.category_map.l2.name,
    category3: product.category_map.l3.name,
    isTIRA: product.isTIRA,
    isBV: product.isBV,
    avg_rating: product.avgRating,
    no_reviews: product.noReviews
  }
  if (loggedIn && !isEmpty(review)) {
    eventData = {
      ...eventData,
      anonymous: review.anonymous,
      rating: review.rating
    }
  }
  return eventData;
}
export const emitEvent = (eventName, eventData) => {
  if (!eventName) return;
  window?.FPI?.event?.emit(eventName, eventData);
};


export const FEEDBACK_VALIDATION_CONFIG_KEY = "customer_review_validation_config";
export const FEEDBACK_VALIDATION_CONFIG_TTL = 86400000;
export const classVariableName = "tira-feedback-service";
